class Compliance {
  constructor(data) {
    this.pk = data.pk;
    this.location = data.location;
    this.user_id = data.user_id;
    this.ip = data.ip;
    this.user_agent = data.user_agent;
    this.event_type = data.event_type;
    this.is_deleted = data.is_deleted;
    this.created_at = data.created_at;
  }
}
export default Compliance;